import { memo, useCallback } from 'react';
import { ITopTag } from 'src/interface';
import { Element, Image, RouterLink as Link } from 'src/components';
import Media from 'src/components/media';
import styles from './style.module.scss';

interface IProps {
    tags?: ITopTag[];
}

const DEFAULT_THUMB =
    'https://baomoi-static.bmcdn.me/Uploaded/article_detail/ic_tag.png';

export default memo(function ContentTopTags({ tags = [] }: IProps) {
    const renderTag = useCallback((tag: ITopTag, i: number) => {
        return (
            <Element
                renderAs="li"
                className={styles['tag-item']}
                key={`keyword_${i}`}
            >
                <Link to={tag.url} title={tag.name}>
                    <Image
                        src={tag.thumb || DEFAULT_THUMB}
                        defaultSrc={DEFAULT_THUMB}
                    />
                    {tag.name}
                </Link>
            </Element>
        );
    }, []);

    const renderTags = useCallback(() => {
        return tags.slice(0, 3).map(renderTag);
    }, [tags]);

    if (!tags.length) {
        return null;
    }

    return (
        <Media className={styles['article-top-tags']}>
            <Media.Content>
                <Element renderAs="ul" className={styles['tag-list']}>
                    {renderTags()}
                </Element>
            </Media.Content>
        </Media>
    );
});
